var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shuttle"},[(_vm.shuttle)?_c('div',{staticClass:"shuttle-title-box"},[_c('div',{staticClass:"shuttle-name"},[_vm._v(_vm._s(_vm.shuttle.Name))]),_c('div',{staticClass:"shuttle-status",class:{
      'closed': _vm.hasClosedStatus,
      'open': _vm.hasOpenStatus,
      'on-hold': _vm.hasHoldStatus,
      'scheduled': _vm.hasScheduledStatus
    }},[_c('span',[_vm._v(_vm._s(_vm.shuttle.Status))])]),_c('div',{staticClass:"shuttle-hours",class:_vm.shuttle.StatusEnglish},[_vm._v(_vm._s(_vm.liftHours))]),_c('div',{staticClass:"shuttle-message"},[_vm._v(_vm._s(_vm.shuttle.Status))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }